import React, {useEffect, useState} from 'react';
import style from "./index.module.scss"
import cn from "classnames";
import Badge from "../../shared/Badge";
import {File} from '../../../services';
import {requestErrorDisplay} from '../../../utils';
import { t } from "i18next";
import VehicleInfoModal from '../VehicleInfoModal/VehicleInfoModal';
import { SquarePen } from 'lucide-react';

const CarsItemCard = ({ isHead, item, onVehicleUpdate }) => {
  const [ isLoading, setLoading ] = useState(false)
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  // const [ avatarData, setAvatarData ] = useState(false)
  // const getAvatarById = () => {
  //   setLoading(true)
  //   File.getImageByType(5, item.id)
  //     .then(res => res.data)
  //     .then(data => {
  //       setAvatarData(data)
  //     })
  //     .catch(e => {
  //       requestErrorDisplay(e)
  //     })
  //     .finally(() => {
  //       setLoading(false)
  //     })
  // }

  // useEffect(() => {
  //   if (!isHead && item?.id) {
  //     getAvatarById()
  //   }
  // }, [isHead, item?.id])

  const handleVehicleClick = () => {
    setShowInfoModal(true);
  };

  const handleInfoModalClose = () => {
    setShowInfoModal(false);
    setIsEditMode(false);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    setIsEditMode(true);
    setShowInfoModal(true);
  };

  return (
    <>
    <div className={cn(style.wrapper, { [style.isHead]: isHead })}>
      {
        isHead && (
          <>
            <div className={style.item} style={{ paddingLeft: '22px'}}>
              {/* <div className={style.item_avatar} style={{ height: "1px" }}></div> */}
              {t("carsHead.modelAndNumber")}
            </div>
            <div className={style.item}>
              {t("carsHead.trailerModelAndNumber")}
            </div>
            <div className={style.item}>
              {t("carsHead.trailerType")}
            </div>
            {/*<div className={style.item}>*/}
            {/*  Водитель*/}
            {/*</div>*/}
            <div className={cn(style.item, style.item_status)}>
              {t("carsHead.status")}
            </div>
            <div className={cn(style.item, style.item_edit)} style={{ paddingRight: "14px", justifyContent: "center" }}>
              {t("profileTwo.buttons.edit")}
            </div>
          </>
        )
      }
      {
        !isHead && (
          <>
            <div className={style.item} onClick={handleVehicleClick} style={{ cursor: 'pointer', paddingLeft: '22px' }}>
              {/* <img
                className={style.item_avatar}
                src={avatarData?.base64 ? `data:${avatarData?.contentType};base64, ${avatarData?.base64}` : '/images/no-photo.png'}
                alt={item.carNumber}
              /> */}
              <p>{item.carModel} {item.carNumber}</p>
            </div>
            <div className={style.item} onClick={handleVehicleClick} style={{ cursor: 'pointer' }}>
              <p>{item.trailerModel} {item.trailerNumber}</p>
            </div>
            <div className={style.item} onClick={handleVehicleClick} style={{ cursor: 'pointer' }}>
              <p>{item.vehicleTypeName} {item.loadingTypeName && (<span> ({item.loadingTypeName}) </span>)}</p>
            </div>
            <div className={cn(style.item, style.item_status)} onClick={handleVehicleClick} style={{ cursor: 'pointer' }}>
              <Badge type={item.isFree ? "green" : "gray"} text={item.isFree ? t("orderBooking.trailerFree") : t("orderBooking.driverBusy")} />
            </div>
            <div className={cn(style.item, style.item_edit)} onClick={handleEditClick} style={{cursor: 'pointer'}}>
              <button
                className={style.buttonEdit}
                title={t("driversCreatePage.buttons.edit") || 'Редактировать'}
              >
                <SquarePen size={20} />
              </button>
            </div>
          </>
        )
      }
    </div>

      <VehicleInfoModal
        isOpen={showInfoModal}
        onClose={handleInfoModalClose}
        vehicleId={item?.id}
        onVehicleUpdate={onVehicleUpdate}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
      />
    </>
  );
};

export default CarsItemCard;